var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#4E4E4E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10767 5.39262V8.0391L9.76171 9.69315",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79955 2.30804C5.77271 1.7451 6.90257 1.42291 8.10765 1.42291C11.7616 1.42291 14.7238 4.38508 14.7238 8.0391C14.7238 11.6931 11.7616 14.6553 8.10765 14.6553C4.45362 14.6553 1.49146 11.6931 1.49146 8.0391C1.49146 6.83403 1.81364 5.70416 2.37658 4.73101",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinute);
export default __webpack_public_path__ + "static/media/Minute.65619c0af3b220d4be6f30568a558f99.svg";
export { ForwardRef as ReactComponent };